import React from "react";
import styled from "styled-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSortDown, faSortUp} from "@fortawesome/pro-thin-svg-icons";

const Row = styled.tr`
  background: var(--color-table-bg-header);
`;

const Cell = styled.th`
  background-color: var(--color-table-bg-header);
  color: var(--color-text-body);
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  white-space: nowrap;
  padding: 10px;
  border-top: 1px solid var(--color-table-border-pageinput);
  border-bottom: 1px solid var(--color-table-border-pageinput);
`;

const Thead = styled.thead`
  & tr {
    box-shadow: 0px -1px 0px 1px var(--color-table-border-pageinput);
  }

  position: sticky;
  top: 0;
`;

const SortIcon = styled(FontAwesomeIcon)`
  color: var(--color-table-sort-icon);
  margin-left: 3px;
  font-size: 13px;
`;

const renderTableColumn = (column) => {
    const {getHeaderProps, render, canFilter} = column;
    return (
        <Cell style={{width: column.width}} key={column.id}>
            <div {...getHeaderProps(column.getSortByToggleProps())}>
                {render("Header")}
                <span>
          {column.isSorted ? (
              column.isSortedDesc ? (
                  <SortIcon icon={faSortDown}/>
              ) : (
                  <SortIcon icon={faSortUp}/>
              )
          ) : (
              ""
          )}
        </span>
            </div>
            <div>
                <span>{canFilter ? render("Filter") : ""}</span>
            </div>
        </Cell>
    );
};

const renderTableRow = (headerGroup) => {
    const {getHeaderGroupProps, headers} = headerGroup;
    return (
        <Row {...getHeaderGroupProps()}>
            {headers.map((column) => renderTableColumn(column))}
        </Row>
    );
};

const TableHead = ({tableInstance}) => {
    const {headerGroups} = tableInstance;

    return (
        <Thead>
            {headerGroups.map((headerGroup) => renderTableRow(headerGroup))}
        </Thead>
    );
};

export default TableHead;
